var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "si-widget si-common-widgets",
        { "waf-match-info-v2": _vm.matchStories },
      ],
    },
    [
      _c(
        "div",
        {
          staticClass: "si-masthead-container si-historic-event-cntnr",
          attrs: { itemscope: "", itemtype: "https://schema.org/NewsArticle" },
        },
        [
          _vm.matchStories
            ? _c("match-info-head", {
                attrs: {
                  isArticleAvailable: _vm.isArticleAvailable,
                  last_updated_label: _vm.translations.last_updated_label,
                  article_button_details: _vm.getArticleButtonDetails(),
                  pageUrl: _vm.getPageUrl(),
                  pageHeadline: _vm.generateHeadline(),
                  article_mt_content: _vm.formatDateString(
                    _vm.story_updated_date,
                    "article_content",
                    true
                  ),
                  article_mt_meta: _vm.formatDateString(
                    _vm.story_updated_date,
                    "article_meta",
                    true
                  ),
                  article_pt_meta: _vm.formatDateString(
                    _vm.story_created_date,
                    "article_meta",
                    true
                  ),
                },
              })
            : _c("match-info-head", {
                attrs: {
                  last_updated_label: _vm.translations.last_updated_label,
                  isArticleAvailable: _vm.isArticleAvailable,
                  article_button_details: _vm.getArticleButtonDetails(),
                  pageUrl: _vm.getPageUrl(),
                  pageHeadline: _vm.generateHeadline(),
                  article_mt_content: _vm.formatDateString(
                    _vm.article_mt,
                    "article_content"
                  ),
                  article_mt_meta: _vm.formatDateString(
                    _vm.article_mt,
                    "article_meta"
                  ),
                  article_pt_meta: _vm.formatDateString(
                    _vm.article_pt,
                    "article_meta"
                  ),
                },
              }),
          _vm._v(" "),
          _vm.matchStories
            ? _c("div", { domProps: { innerHTML: _vm._s(_vm.matchStories) } })
            : _vm.feed_data.length
            ? _c(
                "div",
                {
                  staticClass: "si-infographic-content",
                  attrs: { itemprop: "articleBody" },
                },
                [
                  _vm.show_htoh_image
                    ? _c("div", { key: "match-image", staticClass: "si-row" }, [
                        _c("div", { staticClass: "si-box si-gallery" }, [
                          _c("div", { staticClass: "si-content-wrp" }, [
                            _c(
                              "div",
                              {
                                staticClass: "si-img-wrp",
                                attrs: {
                                  itemtype: "https://schema.org/ImageObject",
                                  itemscope: "",
                                  itemprop: "image",
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "si-img",
                                  attrs: {
                                    importance: "high",
                                    src:
                                      _vm.match_image +
                                      "?w=" +
                                      _vm.image_compression_width,
                                    title: _vm.generateMatchTitle(),
                                    alt: _vm.generateMatchTitle(),
                                  },
                                }),
                                _vm._v(" "),
                                _c("meta", {
                                  attrs: {
                                    itemprop: "url",
                                    content: _vm.match_image,
                                  },
                                }),
                                _vm._v(" "),
                                _c("meta", {
                                  attrs: {
                                    itemprop: "description",
                                    content: _vm.generateMatchTitle(),
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.feed_data, function (comm) {
                    return _c("div", { key: comm.id, staticClass: "si-row" }, [
                      _c(
                        "div",
                        {
                          class: [
                            "si-box",
                            comm.display_pic ? "si-gallery" : "si-comments",
                          ],
                        },
                        [
                          _c("div", { staticClass: "si-content-wrp" }, [
                            comm.body
                              ? _c("div", {
                                  staticClass: "si-text-wrp",
                                  domProps: { innerHTML: _vm._s(comm.body) },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            comm.display_pic
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "si-img-wrp",
                                    attrs: {
                                      itemtype:
                                        "https://schema.org/ImageObject",
                                      itemscope: "",
                                      itemprop: "image",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "si-img",
                                      attrs: {
                                        loading: "lazy",
                                        src:
                                          comm.display_pic +
                                          "?w=" +
                                          _vm.image_compression_width,
                                        title: comm.headline,
                                        alt: comm.headline,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("meta", {
                                      attrs: {
                                        itemprop: "url",
                                        content: comm.display_pic,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("meta", {
                                      attrs: {
                                        itemprop: "description",
                                        content: comm.headline,
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ])
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }